(function () {
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const locale = isEnglish ? 'en-GB' : 'de-DE';
  const copy = isEnglish
    ? { piece: 'piece', pieces: 'pieces', from: 'from', unit: 'sales unit', units: 'sales units', save: 'save', noDiscount: 'without quantity discount', basePrice: 'Base price', youSave: 'You save', moreUntil: 'more sales units to reach', addToCart: 'to cart' }
    : { piece: 'Stück', pieces: 'Stück', from: 'ab', unit: 'VE', units: 'VE', save: 'sparen', noDiscount: 'ohne Mengenrabatt', basePrice: 'Basispreis', youSave: 'Sie sparen', moreUntil: 'VE bis', addToCart: 'in den Warenkorb' };

  if (isEnglish) {
    const localeStyle = document.createElement('style');
    localeStyle.textContent = '.switory-volume__tiers button[aria-pressed=\'true\']::before{content:"ACTIVE"!important}' +
      (window.location.pathname.includes('/products/switory-pe-versandtaschen-selbstklebend-blickdicht')
        ? '.switory-mailers-page .product__media-wrapper::before{content:"OPAQUE · TEAR-RESISTANT · SELF-ADHESIVE"!important}.switory-mailers-page .product__media-wrapper::after{content:"●  Color 3252 C"!important}'
        : '');
    document.head.appendChild(localeStyle);
  }

  const money = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });

  const pieceMoney = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  function discountFor(quantity) {
    if (quantity >= 100) return 30;
    if (quantity >= 50) return 20;
    if (quantity >= 10) return 10;
    return 0;
  }

  function parsePackSize(variant) {
    const value = variant && (variant.option3 || (variant.options && variant.options[2]));
    const digits = String(value || '').replace(/\D/g, '');
    return Number(digits) || 1;
  }

  function currentVariant(root, variants) {
    const productInfo = root.closest('product-info') || document;
    const idInput = productInfo.querySelector('form[action*="/cart/add"] [name="id"]');
    const id = idInput ? String(idInput.value) : '';
    return variants.find((variant) => String(variant.id) === id) || variants[0];
  }

  function quantityInput(root) {
    const productInfo = root.closest('product-info') || document;
    return productInfo.querySelector('input[name="quantity"]');
  }

  function formatTierUnits(node, packSize) {
    const minimum = Number(node.dataset.tierMin) || 1;
    const maximum = Number(node.dataset.tierMax) || 0;
    const minimumUnits = minimum * packSize;
    node.textContent = maximum
      ? minimumUnits.toLocaleString(locale) + '–' + (maximum * packSize).toLocaleString(locale) + ' ' + copy.pieces
      : copy.from + ' ' + minimumUnits.toLocaleString(locale) + ' ' + copy.pieces;
  }

  function decorateColorOptions(scope) {
    scope.querySelectorAll('.product-form__input').forEach((fieldset) => {
      const legend = fieldset.querySelector('.form__label');
      if (!legend || !/(farbe|color)/i.test(legend.textContent)) return;
      fieldset.classList.add('switory-color-options');
      fieldset.parentElement.style.setProperty('--switory-color-count', fieldset.querySelectorAll('label').length);
      fieldset.querySelectorAll('label').forEach((label) => {
        if (label.querySelector('.switory-color-dot')) return;
        const name = label.textContent.trim();
        let color = '';
        if (/(türkis|turquoise|3252)/i.test(name)) color = '#20cbbb';
        else if (/(sakura|hellrosa|light pink|203)/i.test(name)) color = '#f3b8ca';
        else if (/(rosa|pink|2046)/i.test(name)) color = '#ef6e9e';
        else if (/(graublau|gray blue|grey blue|644)/i.test(name)) color = '#8fa8bc';
        else if (/(schwarz|black)/i.test(name)) color = '#171717';
        else if (/(weiß|weiss|white)/i.test(name)) color = '#ffffff';
        else if (/(braun|brown)/i.test(name)) color = '#c99a52';
        else if (/(violett|violet)/i.test(name)) color = '#8f6bb3';
        else if (/(lavendel|lavender)/i.test(name)) color = '#c6aed7';
        else if (/(hellblau|light blue)/i.test(name)) color = '#a7d8eb';
        else if (/(blau|blue)/i.test(name)) color = '#2f59d9';
        else if (/orange/i.test(name)) color = '#ef7d24';
        else if (/(rot|red)/i.test(name)) color = '#c93c4b';
        if (!color) return;
        const dot = document.createElement('span');
        dot.className = 'switory-color-dot';
        dot.style.backgroundColor = color;
        dot.setAttribute('aria-hidden', 'true');
        label.prepend(dot);
      });
    });
  }

  function init(root) {
    if (root.dataset.switoryReady === 'true') return;
    const dataNode = root.parentElement.querySelector('[data-switory-variants]');
    if (!dataNode) return;

    let variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    root.dataset.switoryReady = 'true';
    document.body.classList.add('switory-mailers-page');
    if (!document.getElementById('switory-subscription-style')) {
      const style = document.createElement('style');
      style.id = 'switory-subscription-style';
      style.textContent = ".switory-subscription-integrated .shopify-block:has(.shopify_subscriptions_app_container){display:none!important}.switory-volume__subscription{border-top:1px solid #dedede;padding:14px 12px 16px;background:#fff;color:#242424}.switory-volume__subscription-main{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}.switory-volume__subscription-choice{display:flex;align-items:flex-start;gap:10px;cursor:pointer;min-width:0}.switory-volume__subscription-choice input{width:17px;height:17px;margin:2px 0 0;flex:none;accent-color:#e90046}.switory-volume__subscription-choice span{display:flex;align-items:center;flex-wrap:wrap;gap:6px}.switory-volume__subscription-choice strong{font-size:13px;line-height:1.35}.switory-volume__subscription-choice b{background:#e90046;color:#fff;font-size:11px;line-height:1;padding:4px 6px}.switory-volume__subscription-price{font-size:13px;white-space:nowrap;text-align:right}.switory-volume__subscription p{font-size:11px;line-height:1.4;color:#666;margin:4px 0 9px 27px}.switory-volume__subscription-frequency{display:flex;align-items:center;gap:10px;margin-left:27px;font-size:11px;font-weight:600}.switory-volume__subscription-frequency select{font:inherit;font-size:12px;min-height:30px;padding:3px 26px 3px 8px;border:1px solid #c8c8c8;border-radius:2px;background:#fff;color:#242424}.switory-volume__subscription.is-active{background:#fff8fa}@media(max-width:600px){.switory-volume__subscription-main{flex-wrap:wrap}.switory-volume__subscription-price{margin-left:27px;text-align:left}}";
      document.head.appendChild(style);
    }

    const productInfo = root.closest('product-info') || document;
    const isBubbleWrap = document.body.classList.contains('switory-bubble-wrap-page');
    decorateColorOptions(productInfo);

    const availabilityCopy = isEnglish
      ? {
          switched: 'Available combination: {combination}. We switched to this matching in-stock variant.',
          unavailable: 'This option is currently unavailable. Please choose one of the highlighted in-stock combinations.'
        }
      : {
          switched: 'Verfügbare Kombination: {combination}. Wir haben automatisch auf diese passende, lieferbare Variante gewechselt.',
          unavailable: 'Diese Auswahl ist aktuell nicht verfügbar. Bitte wählen Sie eine der hervorgehobenen lieferbaren Kombinationen.'
        };
    const availableVariants = variants.filter((variant) => variant.available !== false);
    let syncingOptions = false;

    function optionFieldsets() {
      return Array.from(productInfo.querySelectorAll('fieldset.product-form__input')).filter((fieldset) =>
        fieldset.querySelector('input[type="radio"]')
      );
    }

    function selectedOptions(fieldsets) {
      return fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
    }

    function availabilityFeedback() {
      let feedback = productInfo.querySelector('[data-switory-availability-feedback]');
      if (!feedback) {
        feedback = document.createElement('div');
        feedback.className = 'switory-availability-feedback';
        feedback.dataset.switoryAvailabilityFeedback = '';
        feedback.setAttribute('role', 'status');
        feedback.setAttribute('aria-live', 'polite');
        feedback.hidden = true;
        const fieldsets = optionFieldsets();
        const anchor = fieldsets[fieldsets.length - 1];
        if (anchor) anchor.insertAdjacentElement('afterend', feedback);
      }
      const storedMessage = document.body.dataset.switoryAvailabilityMessage || '';
      if (storedMessage) {
        feedback.textContent = storedMessage;
        feedback.hidden = false;
      }
      return feedback;
    }

    function showAvailabilityFeedback(variant) {
      const combination = variant.options.filter(Boolean).join(' · ');
      const message = availabilityCopy.switched.replace('{combination}', combination);
      document.body.dataset.switoryAvailabilityMessage = message;
      const feedback = availabilityFeedback();
      feedback.textContent = message;
      feedback.hidden = false;
    }

    function showUnavailableFeedback() {
      document.body.dataset.switoryAvailabilityMessage = availabilityCopy.unavailable;
      const feedback = availabilityFeedback();
      feedback.textContent = availabilityCopy.unavailable;
      feedback.hidden = false;
    }

    function clearAvailabilityFeedback() {
      delete document.body.dataset.switoryAvailabilityMessage;
      const feedback = productInfo.querySelector('[data-switory-availability-feedback]');
      if (feedback) {
        feedback.textContent = '';
        feedback.hidden = true;
      }
    }

    function findBestAvailableVariant(optionIndex, value, selected) {
      return availableVariants
        .filter((variant) => variant.options[optionIndex] === value)
        .sort((left, right) => {
          const score = (variant) => variant.options.reduce((total, option, index) =>
            total + (index !== optionIndex && option === selected[index] ? 1 : 0), 0);
          return score(right) - score(left);
        })[0];
    }

    function applyAvailableVariant(variant, fieldsets) {
      syncingOptions = true;
      fieldsets.forEach((fieldset, index) => {
        const matchingInput = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) =>
          radio.value === variant.options[index]
        );
        if (matchingInput) matchingInput.checked = true;
      });
      showAvailabilityFeedback(variant);
      window.setTimeout(() => {
        syncingOptions = false;
        decorateColorOptions(productInfo);
        refresh();
      }, 0);
    }

    productInfo.addEventListener('change', (event) => {
      if (syncingOptions || !(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
      const fieldset = event.target.closest('fieldset.product-form__input');
      if (!fieldset) return;
      const fieldsets = optionFieldsets();
      const optionIndex = fieldsets.indexOf(fieldset);
      if (optionIndex < 0) return;
      const selected = selectedOptions(fieldsets);
      const exactVariant = availableVariants.find((variant) =>
        variant.options.every((option, index) => option === selected[index])
      );
      if (exactVariant) {
        clearAvailabilityFeedback();
        return;
      }
      const replacement = findBestAvailableVariant(optionIndex, event.target.value, selected);
      if (!replacement) {
        showUnavailableFeedback();
        return;
      }
      applyAvailableVariant(replacement, fieldsets);
    }, true);

    availabilityFeedback();

    function translateBubbleWrapOptions() {
      if (!isBubbleWrap || !isEnglish) return;
      productInfo.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
        const walker = document.createTreeWalker(fieldset, NodeFilter.SHOW_TEXT);
        let textNode;
        while ((textNode = walker.nextNode())) {
          textNode.data = textNode.data
            .replace(/Rollenlänge/g, 'Roll Length')
            .replace(/Rollenbreite/g, 'Roll Width')
            .replace(/Packungsgröße/g, 'Pack Size')
            .replace(/1 Rolle/g, '1 roll');
        }
      });
    }


    function parsePlanPrice(text) {
      const value = String(text || '').replace(/[^\d.,-]/g, '');
      return Number(value.lastIndexOf(',') > value.lastIndexOf('.')
        ? value.replace(/\./g, '').replace(',', '.')
        : value.replace(/,/g, ''));
    }

    function syncSubscriptionControls(discount, variantId) {
      const app = productInfo.querySelector('.shopify_subscriptions_app_container');
      const section = app && app.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + variantId + '"]');
      const plans = section ? Array.from(section.querySelectorAll('input[data-radio-type="selling_plan"]')) : [];
      if (!plans.length) return;
      let controls = root.querySelector('.switory-volume__subscription');
      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'switory-volume__subscription';
        controls.innerHTML = '<div class="switory-volume__subscription-main"><label class="switory-volume__subscription-choice"><input type="checkbox" data-switory-subscribe><span><strong>' + (isEnglish ? 'Subscribe & Save: regular deliveries' : 'Spar-Abo: regelmäßig liefern lassen') + '</strong><b>−5 %</b></span></label><strong class="switory-volume__subscription-price" data-switory-subscription-price aria-live="polite"></strong></div><p>' + (isEnglish ? 'Save 5% on every delivery. Pause or cancel anytime.' : '5 % bei jeder Lieferung sparen. Jederzeit pausieren oder kündigen.') + '</p><label class="switory-volume__subscription-frequency">' + (isEnglish ? 'Delivery & payment' : 'Lieferung & Zahlung') + '<select data-switory-subscription-frequency aria-label="' + (isEnglish ? 'Delivery frequency' : 'Lieferfrequenz') + '"></select></label>';
        root.querySelector('.switory-volume__details').before(controls);
        controls.querySelector('[data-switory-subscribe]').addEventListener('change', (event) => {
          const selectedId = controls.querySelector('select').value;
          const section = productInfo.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
          const selected = Array.from(section?.querySelectorAll('input[data-radio-type="selling_plan"]') || []).find((radio) => radio.dataset.sellingPlanId === selectedId);
          const oneTime = section?.querySelector('input[data-radio-type="one_time_purchase"]');
          const target = event.target.checked ? selected : oneTime;
          if (target) target.click();
          window.setTimeout(refresh, 0);
        });
        controls.querySelector('select').addEventListener('change', (event) => {
          if (controls.querySelector('[data-switory-subscribe]').checked) {
            const section = productInfo.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
            const selected = Array.from(section?.querySelectorAll('input[data-radio-type="selling_plan"]') || []).find((radio) => radio.dataset.sellingPlanId === event.target.value);
            if (selected) selected.click();
          }
          window.setTimeout(refresh, 0);
        });
      }
      const select = controls.querySelector('select');
      const ids = plans.map((plan) => plan.dataset.sellingPlanId).join(',');
      if (select.dataset.planIds !== ids) {
        const previous = select.value;
        select.replaceChildren();
        plans.forEach((plan, index) => {
          const option = document.createElement('option');
          option.value = plan.dataset.sellingPlanId;
          option.textContent = isEnglish
            ? ['Every week', 'Every 2 weeks', 'Every 4 weeks'][index] || plan.getAttribute('aria-label')
            : ['Jede Woche', 'Alle 2 Wochen', 'Alle 4 Wochen'][index] || plan.getAttribute('aria-label');
          select.appendChild(option);
        });
        select.dataset.planIds = ids;
        select.value = plans.some((plan) => plan.dataset.sellingPlanId === previous) ? previous : plans[plans.length - 1].dataset.sellingPlanId;
      }
      const selectedPlan = plans.find((plan) => plan.checked);
      if (selectedPlan) select.value = selectedPlan.dataset.sellingPlanId;
      controls.querySelector('[data-switory-subscribe]').checked = Boolean(selectedPlan);
      controls.classList.toggle('is-active', Boolean(selectedPlan));
      const displayPlan = plans.find((plan) => plan.dataset.sellingPlanId === select.value) || plans[0];
      const planPrice = parsePlanPrice(displayPlan.dataset.variantPrice);
      const unitPrice = Math.round(planPrice * (1 - discount / 100) * 100) / 100;
      controls.querySelector('[data-switory-subscription-price]').textContent = money.format(unitPrice) + (isBubbleWrap ? (isEnglish ? ' / roll / delivery' : ' / Rolle / Lieferung') : (isEnglish ? ' / unit / delivery' : ' / VE / Lieferung'));
      productInfo.classList.add('switory-subscription-integrated');
    }

    function refresh() {
      translateBubbleWrapOptions();
      let variant = currentVariant(root, variants);
      if (isBubbleWrap) {
        const selected = Array.from(productInfo.querySelectorAll('fieldset.product-form__input')).map((fieldset) => {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : '';
        });
        const selectedVariant = variants.find((candidate) => candidate.option1 === selected[0] && candidate.option2 === selected[1]);
        if (selectedVariant) variant = selectedVariant;
      }
      if (!variant) return;

      const input = quantityInput(root);
      const quantity = Math.max(1, Number(input && input.value) || 1);
      const basePrice = Number(variant.price) / 100;
      const packSize = parsePackSize(variant);
      const discount = discountFor(quantity);
      const discountedUnit = Math.ceil(basePrice * (1 - discount / 100) * 100) / 100;
      const total = discountedUnit * quantity;
      const regularTotal = basePrice * quantity;
      const savings = regularTotal - total;

      root.querySelectorAll('[data-tier-price]').forEach((node) => {
        const rate = Number(node.dataset.tierPrice);
        const tierPrice = Math.ceil(basePrice * (1 - rate / 100) * 100) / 100;
        node.textContent = money.format(tierPrice) + (isBubbleWrap ? (isEnglish ? ' / roll' : ' / Rolle') : ' / ' + copy.unit);
      });

      if (isBubbleWrap) {
        const tierRanges = [[1, 9], [10, 49], [50, 99], [100, 0]];
        root.querySelectorAll('.switory-volume__tier-range').forEach((node, index) => {
          const range = tierRanges[index] || tierRanges[0];
          node.textContent = range[0].toLocaleString(locale) + (range[1] ? '–' + range[1].toLocaleString(locale) : '+') + (isEnglish ? ' rolls' : ' Rollen');
        });
      }

      root.querySelectorAll('[data-tier-piece-price]').forEach((node) => {
        node.hidden = isBubbleWrap;
        if (isBubbleWrap) return;
        const rate = Number(node.dataset.tierPiecePrice);
        const tierPrice = Math.ceil(basePrice * (1 - rate / 100) * 100) / 100;
        node.textContent = pieceMoney.format(tierPrice / packSize) + ' / ' + copy.piece;
      });

      root.querySelectorAll('[data-tier-units]').forEach((node) => {
        node.hidden = isBubbleWrap;
        if (!isBubbleWrap) formatTierUnits(node, packSize);
      });

      root.querySelectorAll('[data-tier-saving]').forEach((node) => {
        const rate = Number(node.dataset.tierSaving);
        const tierPrice = Math.ceil(basePrice * (1 - rate / 100) * 100) / 100;
        const savingPerUnit = basePrice - tierPrice;
        const isTierCard = node.classList.contains('switory-volume__tier-saving');
        if (rate > 0 && isBubbleWrap && isEnglish) {
          node.textContent = (isTierCard ? 'Save ' : '−' + rate + ' % · Save ') + money.format(savingPerUnit) + ' / roll';
        } else if (rate > 0 && isBubbleWrap) {
          node.textContent = isTierCard
            ? money.format(savingPerUnit) + ' / Rolle sparen'
            : '−' + rate + ' % · ' + money.format(savingPerUnit) + ' / Rolle sparen';
        } else if (rate > 0 && isEnglish) {
          node.textContent = (isTierCard ? 'Save ' : '−' + rate + ' % · Save ') + money.format(savingPerUnit) + ' / ' + copy.unit;
        } else if (rate > 0) {
          node.textContent = isTierCard
            ? money.format(savingPerUnit) + ' / VE sparen'
            : '−' + rate + ' % · ' + money.format(savingPerUnit) + ' / VE sparen';
        } else {
          node.textContent = isTierCard ? copy.noDiscount : copy.basePrice;
        }
      });

      root.querySelectorAll('[data-switory-tier]').forEach((button) => {
        const minimum = Number(button.dataset.switoryTier);
        const active = minimum === 1
          ? quantity < 10
          : minimum === 10
            ? quantity >= 10 && quantity < 50
            : minimum === 50
              ? quantity >= 50 && quantity < 100
              : quantity >= 100;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const totalUnits = quantity * packSize;
      const itemLabel = root.dataset.switoryItemLabel || copy.pieces;
      const totalUnitsNode = root.querySelector('[data-switory-total-units]');
      if (totalUnitsNode && isBubbleWrap) {
        totalUnitsNode.textContent =
          quantity.toLocaleString(locale) + (isEnglish ? (quantity === 1 ? ' sales unit × ' : ' sales units × ') : ' VE × ') +
          packSize.toLocaleString(locale) + (isEnglish ? ' roll = ' : ' Rolle = ') +
          totalUnits.toLocaleString(locale) + (isEnglish ? (totalUnits === 1 ? ' roll' : ' rolls') : (totalUnits === 1 ? ' Rolle' : ' Rollen'));
      } else if (totalUnitsNode) {
        totalUnitsNode.textContent =
          quantity.toLocaleString(locale) + ' ' + (quantity === 1 ? copy.unit : copy.units) + ' × ' +
          packSize.toLocaleString(locale) + ' ' + copy.pieces + ' = ' +
          totalUnits.toLocaleString(locale) + ' ' + itemLabel;
      }

      root.querySelector('[data-switory-savings]').textContent = savings > 0
        ? copy.youSave + ' ' + money.format(savings)
        : isBubbleWrap
          ? (isEnglish ? 'Only ' + Math.max(0, 10 - quantity) + ' rolls until −10%' : 'Noch ' + Math.max(0, 10 - quantity) + ' Rollen bis −10 %')
          : Math.max(0, 10 - quantity) + ' ' + copy.moreUntil + ' −10 %';

      syncSubscriptionControls(discount, variant.id);
      const selectedPlan = productInfo.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + variant.id + '"] input[data-radio-type="selling_plan"]:checked');
      const planUnitPrice = parsePlanPrice(selectedPlan?.dataset.variantPrice);
      const subscriptionUnit = Math.round(planUnitPrice * (1 - discount / 100) * 100) / 100;
      const buttonTotal = selectedPlan && Number.isFinite(subscriptionUnit) && subscriptionUnit > 0
        ? subscriptionUnit * quantity
        : total;

      const addButton = productInfo.querySelector('.product-form__submit');
      if (addButton) {
        const label = addButton.querySelector('span') || addButton;
        label.textContent = isBubbleWrap
          ? quantity.toLocaleString(locale) + (isEnglish ? (quantity === 1 ? ' roll to cart · ' : ' rolls to cart · ') : (quantity === 1 ? ' Rolle in den Warenkorb · ' : ' Rollen in den Warenkorb · ')) + money.format(buttonTotal)
          : quantity.toLocaleString(locale) + ' ' + (quantity === 1 ? copy.unit : copy.units) + ' ' + copy.addToCart + ' · ' + money.format(buttonTotal);
      }
    }

    root.addEventListener('click', (event) => {
      const tier = event.target.closest('[data-switory-tier]');
      if (!tier) return;
      const input = quantityInput(root);
      if (!input) return;
      input.value = tier.dataset.switoryTier;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      refresh();
    });

    document.addEventListener('change', (event) => {
      if (!productInfo.contains(event.target)) return;
      [120, 360, 650, 1200, 2400].forEach((delay) => {
        window.setTimeout(() => {
          decorateColorOptions(productInfo);
          refresh();
        }, delay);
      });
    });

    document.addEventListener('input', (event) => {
      if (event.target === quantityInput(root)) refresh();
    });

    window.setTimeout(refresh, 80);
  }

  function initAll() {
    document.querySelectorAll('[data-switory-volume]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  new MutationObserver(initAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


(function () {
  function mountBuyNow() {
    if (!document.body.classList.contains('switory-kraft-mailers-page')) return;

    document.querySelectorAll('.product__info-container product-form').forEach((productForm) => {
      const form = productForm.querySelector('form');
      const buttons = form?.querySelector('.product-form__buttons');
      const addButton = buttons?.querySelector('.product-form__submit');
      if (!form || !buttons || !addButton || buttons.querySelector('.switory-buy-now')) return;

      const buyButton = document.createElement('button');
      buyButton.type = 'button';
      buyButton.className = 'switory-buy-now';
      buyButton.textContent = document.documentElement.lang.toLowerCase().startsWith('en') ? 'Buy now' : 'Jetzt kaufen';
      buttons.appendChild(buyButton);

      const cartLabel = addButton.querySelector('span');
      const cartText = document.documentElement.lang.toLowerCase().startsWith('en') ? 'Add to cart' : 'In den Warenkorb';
      const syncCartLabel = () => {
        if (cartLabel && !addButton.disabled && cartLabel.textContent !== cartText) {
          cartLabel.textContent = cartText;
        }
      };
      if (cartLabel) {
        new MutationObserver(syncCartLabel).observe(cartLabel, { childList: true, characterData: true });
      }

      let busy = false;
      const syncDisabled = () => {
        buyButton.disabled = busy || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
        syncCartLabel();
      };
      new MutationObserver(syncDisabled).observe(addButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
      syncDisabled();

      buyButton.addEventListener('click', async () => {
        if (buyButton.disabled) return;
        const data = new FormData(form);
        const quantity = document.querySelector(`input[name="quantity"][form="${form.id}"]`);
        if (quantity) data.set('quantity', quantity.value);
        if (!data.get('id')) return;

        busy = true;
        syncDisabled();
        buyButton.setAttribute('aria-busy', 'true');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            body: data,
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || error.message || 'Unable to add to cart');
          }
          window.location.assign(`${root}checkout`);
        } catch (error) {
          productForm.handleErrorMessage?.(error.message);
          buyButton.removeAttribute('aria-busy');
          busy = false;
          syncDisabled();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBuyNow, { once: true });
  } else {
    mountBuyNow();
  }
  new MutationObserver(mountBuyNow).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Show only the selected variant's Amazon gallery for the kraft bubble mailers. */
(function () {
  if (!/\/products\/kraftpapier-luftpolstertaschen-selbstklebend-gepolstert\/?$/.test(location.pathname)) return;

  const sourceGroups = {
    '55410418549065': ['41rw4oVtrAL','41t0z9gCTsL','411ZYy7OYBL','416HG7U8YaL','4131RYFbgOL','41S4vCEuH8L'],
    '55410418581833': ['41ovtDdq2IL','41B6uW81WSL','411ZYy7OYBL','41EnqcvdAEL','41WPvwuyLyL','41S4vCEuH8L'],
    '55410418614601': ['41Q6WGHEY1L','41-Pq792ajL','411ZYy7OYBL','5111MtboVXL','41o8WQl7baL','41S4vCEuH8L'],
    '55410418647369': ['31TzmousjpL','316qvXOqfQL','410V5yKvO5L','41A75JdVSVL','41QilJryY8L','41I4uUecp-L','51CQO2XrfNL','41sdUlS0wTL'],
    '55410418680137': ['310XmOe3rBL','31+Kyq1FpqL','41do01tbe5L','41MUeCsWyYL','4139AlowLiL','41I4uUecp-L','51gJhxl18fL','41sdUlS0wTL'],
    '55410418712905': ['313LlwJXWHL','31ILJWPwCEL','41I4uUecp-L','41sdUlS0wTL'],
    '55410418745673': ['31kw3hwigwL','317fz-oOtQL','41Ok8Yzf1bL','41tWhGuqZPL','41Dgn6Z1hiL','41I4uUecp-L','51y03NnvizL','41sdUlS0wTL'],
    '55410418778441': ['31rQLUHW4FL','41T5JJqKjCL','41z+dHmqiDL','41beb+XcmkL','41+4rakdzIL','51zrE4uD-7L','416rIhm3gwL','31akdr4K9sL'],
    '55410418811209': ['31YfR1OCggL','31sFJnDy85L','416OmNz47HL','41uGitsxYnL','41OOmQlHldL','41+4rakdzIL','41rI8jS1WVL','416rIhm3gwL'],
    '55410418843977': ['310DZB4N3+L','31tKZPysZeL','41+4rakdzIL','416rIhm3gwL'],
    '55410418876745': ['31F5XTSykIL','31eOMUlkIdL','41glBUsPLEL','41eTISF6LXL','41V2se6ZufL','41+4rakdzIL','51nX7WrfLsL','416rIhm3gwL']
  };
  const groups = Object.fromEntries(Object.entries(sourceGroups).map(([variantId, ids]) => [
    variantId,
    new Set(ids.map((id) => id === '31F5XTSykIL'
      ? 'switory-white-g-25x35-main.jpg'
      : 'switory-bubble-' + id.replace(/\+/g, '_') + '.jpg'))
  ]));
  const style = document.createElement('style');
  style.textContent = 'media-gallery [data-switory-variant-hidden], product-modal [data-switory-variant-hidden] { display: none !important; }';
  document.head.appendChild(style);

  function currentVariantId() {
    return new URLSearchParams(location.search).get('variant') ||
      document.querySelector('product-info form[action*="/cart/add"] input[name="id"]')?.value ||
      '55410418549065';
  }

  function normalizeFilename(name) {
    if (name === 'switory-kraft-c-white-main-hd.jpg') return 'switory-bubble-31YfR1OCggL.jpg';
    if (name === 'switory-bubble-31F5XTSykIL-hd.jpg') return 'switory-white-g-25x35-main.jpg';
    return name.replace(/-hd\.jpg$/, '.jpg');
  }

  function filename(node) {
    const source = node.querySelector('img')?.getAttribute('src') || '';
    return normalizeFilename(source.split('?')[0].split('/').pop() || '');
  }

  function show(node, visible) {
    if (visible) node.removeAttribute('data-switory-variant-hidden');
    else node.setAttribute('data-switory-variant-hidden', '');
  }

  function refreshGallery() {
    const allowed = groups[currentVariantId()];
    const gallery = document.querySelector('media-gallery');
    if (!allowed || !gallery) return;
    const slides = [...gallery.querySelectorAll('.product__media-list > li[data-media-id]')];
    if (!slides.length) return;
    let firstVisible = null;
    for (const slide of slides) {
      const visible = allowed.has(filename(slide));
      show(slide, visible);
      if (visible && !firstVisible) firstVisible = slide;
    }
    for (const thumb of gallery.querySelectorAll('.thumbnail-list__item[data-target]')) {
      show(thumb, allowed.has(filename(thumb)));
    }
    const modal = document.querySelector('product-modal');
    if (modal) {
      for (const media of modal.querySelectorAll('.product-media-modal__content > [data-media-id]')) {
        show(media, allowed.has(normalizeFilename(media.getAttribute('src')?.split('?')[0].split('/').pop() || '')));
      }
    }
    const activeSlide = slides.find((slide) => slide.classList.contains('is-active'));
    if (firstVisible && (!activeSlide || !allowed.has(filename(activeSlide)))) {
      gallery.setActiveMedia?.(firstVisible.dataset.mediaId, true);
    }
  }

  let queued = false;
  function queueRefresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      refreshGallery();
    });
  }
  function onVariantChange() {
    [0, 150, 500].forEach((delay) => setTimeout(queueRefresh, delay));
  }
  document.addEventListener('change', onVariantChange);
  window.addEventListener('popstate', onVariantChange);
  document.addEventListener('shopify:section:load', onVariantChange);
  new MutationObserver(queueRefresh).observe(document.body, { childList: true, subtree: true });
  onVariantChange();
})();

/* Use Shopify-hosted high-resolution images for this product's active gallery. */
(function () {
  if (!/\/products\/kraftpapier-luftpolstertaschen-selbstklebend-gepolstert\/?$/.test(location.pathname)) return;
  const base = 'https://cdn.shopify.com/s/files/1/0948/4514/1321/files/';
  const selector = [
    'media-gallery .product__media-list > li:not([data-switory-variant-hidden]) img',
    'media-gallery .thumbnail-list__item:not([data-switory-variant-hidden]) img',
    'product-modal .product-media-modal__content > img[data-media-id]:not([data-switory-variant-hidden])'
  ].join(', ');
  function highUrl(img) {
    const source = (img.getAttribute('src') || '') + ' ' + (img.getAttribute('srcset') || '');
    const match = source.match(/(switory-bubble-[^/?]+\.jpg|switory-white-g-25x35-main\.jpg)/);
    if (!match || match[1].endsWith('-hd.jpg')) return null;
    if (match[1] === 'switory-bubble-31YfR1OCggL.jpg') return base + 'switory-kraft-c-white-main-hd.jpg';
    if (match[1] === 'switory-white-g-25x35-main.jpg') return base + 'switory-bubble-31F5XTSykIL-hd.jpg';
    return base + match[1].replace(/\.jpg$/, '-hd.jpg');
  }
  function upgrade() {
    document.querySelectorAll(selector).forEach((img) => {
      const url = highUrl(img);
      if (!url) return;
      img.removeAttribute('srcset');
      img.src = url;
    });
  }
  let queued = false;
  function queueUpgrade() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; upgrade(); });
  }
  upgrade();
  document.addEventListener('DOMContentLoaded', queueUpgrade, { once: true });
  document.addEventListener('change', queueUpgrade, true);
  window.addEventListener('popstate', queueUpgrade);
  document.addEventListener('shopify:section:load', queueUpgrade);
  new MutationObserver(queueUpgrade).observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['src', 'srcset', 'data-switory-variant-hidden']
  });
})();

/* Show the selected color and size variant's own Amazon gallery. */
(function () {
  if (!/\/products\/switory-luftpolsterumschlage-a5-versandtaschen-15-3-cm-x-26-9-cm-warensendung-umschlage-a5-versandtaschen-luftpolster-fur-cds-schmuck-kosmetik-geschenke-schwarz\/?$/.test(location.pathname)) return;
  const groups = Object.fromEntries(Object.entries({"55227882701129":["switory-color-M0016-0800-00-31362-01-hd.jpg","switory-color-M0016-0800-00-31362-02-hd.jpg","switory-color-M0016-0800-00-31362-03-hd.jpg","switory-color-M0016-0800-00-31362-04-hd.jpg","switory-color-M0016-0800-00-31362-05-hd.jpg","switory-color-M0016-0800-00-31362-06-hd.jpg","switory-color-M0016-0800-00-31362-07-hd.jpg"],"55227882832201":["switory-color-M0022-0600-00-31362-01-hd.jpg","switory-color-M0022-0600-00-31362-02-hd.jpg","switory-color-M0022-0600-00-31362-03-hd.jpg","switory-color-M0022-0600-00-31362-04-hd.jpg","switory-color-M0022-0600-00-31362-05-hd.jpg","switory-color-M0022-0600-00-31362-06-hd.jpg","switory-color-M0022-0600-00-31362-07-hd.jpg"],"55227882864969":["switory-color-M0023-0600-00-31362-01-hd.jpg","switory-color-M0023-0600-00-31362-02-hd.jpg","switory-color-M0023-0600-00-31362-03-hd.jpg","switory-color-M0023-0600-00-31362-04-hd.jpg","switory-color-M0023-0600-00-31362-05-hd.jpg","switory-color-M0023-0600-00-31362-06-hd.jpg","switory-color-M0023-0600-00-31362-07-hd.jpg"],"55227882766665":["switory-color-M0024-0600-00-31362-01-hd.jpg","switory-color-M0024-0600-00-31362-02-hd.jpg","switory-color-M0024-0600-00-31362-03-hd.jpg","switory-color-M0024-0600-00-31362-04-hd.jpg","switory-color-M0024-0600-00-31362-05-hd.jpg","switory-color-M0024-0600-00-31362-06-hd.jpg","switory-color-M0024-0600-00-31362-07-hd.jpg","switory-color-M0024-0600-00-31362-08-hd.jpg"],"55227882668361":["switory-color-M0033-0800-00-31362-01-hd.jpg","switory-color-M0033-0800-00-31362-02-hd.jpg","switory-color-M0033-0800-00-31362-03-hd.jpg","switory-color-M0033-0800-00-31362-04-hd.jpg","switory-color-M0033-0800-00-31362-05-hd.jpg","switory-color-M0033-0800-00-31362-06-hd.jpg","switory-color-M0033-0800-00-31362-07-hd.jpg"],"55227882799433":["switory-color-M0241-0600-00-31362-01-hd.jpg","switory-color-M0241-0600-00-31362-02-hd.jpg","switory-color-M0241-0600-00-31362-03-hd.jpg","switory-color-M0241-0600-00-31362-04-hd.jpg","switory-color-M0241-0600-00-31362-05-hd.jpg","switory-color-M0241-0600-00-31362-06-hd.jpg","switory-color-M0241-0600-00-31362-07-hd.jpg"],"53623853416777":["switory-color-M0864-0600-00-31362-01-hd.jpg"],"55227882602825":["switory-color-M0865-0800-00-31362-01-hd.jpg","switory-color-M0865-0800-00-31362-02-hd.jpg","switory-color-M0865-0800-00-31362-03-hd.jpg","switory-color-M0865-0800-00-31362-04-hd.jpg","switory-color-M0865-0800-00-31362-05-hd.jpg","switory-color-M0865-0800-00-31362-06-hd.jpg","switory-color-M0865-0800-00-31362-07-hd.jpg"],"55227882635593":["switory-color-M0866-0800-00-31362-01-hd.jpg","switory-color-M0866-0800-00-31362-02-hd.jpg","switory-color-M0866-0800-00-31362-03-hd.jpg","switory-color-M0866-0800-00-31362-04-hd.jpg","switory-color-M0866-0800-00-31362-05-hd.jpg","switory-color-M0866-0800-00-31362-06-hd.jpg","switory-color-M0866-0800-00-31362-07-hd.jpg"],"55227883094345":["switory-color-M0867-0250-00-31362-01-hd.jpg","switory-color-M0867-0250-00-31362-02-hd.jpg","switory-color-M0867-0250-00-31362-03-hd.jpg","switory-color-M0867-0250-00-31362-04-hd.jpg","switory-color-M0867-0250-00-31362-05-hd.jpg","switory-color-M0867-0250-00-31362-06-hd.jpg","switory-color-M0867-0250-00-31362-07-hd.jpg"],"55227883061577":["switory-color-M0999-0250-00-31362-01-hd.jpg","switory-color-M0999-0250-00-31362-02-hd.jpg","switory-color-M0999-0250-00-31362-03-hd.jpg","switory-color-M0999-0250-00-31362-04-hd.jpg","switory-color-M0999-0250-00-31362-05-hd.jpg","switory-color-M0999-0250-00-31362-06-hd.jpg","switory-color-M0999-0250-00-31362-07-hd.jpg"],"55227883127113":["switory-color-M1241-0250-00-31362-01-hd.jpg","switory-color-M1241-0250-00-31362-02-hd.jpg","switory-color-M1241-0250-00-31362-03-hd.jpg","switory-color-M1241-0250-00-31362-04-hd.jpg","switory-color-M1241-0250-00-31362-05-hd.jpg","switory-color-M1241-0250-00-31362-06-hd.jpg","switory-color-M1241-0250-00-31362-07-hd.jpg"],"55227882897737":["switory-color-M1339-0600-00-31362-01-hd.jpg","switory-color-M1339-0600-00-31362-02-hd.jpg","switory-color-M1339-0600-00-31362-03-hd.jpg","switory-color-M1339-0600-00-31362-04-hd.jpg","switory-color-M1339-0600-00-31362-05-hd.jpg","switory-color-M1339-0600-00-31362-06-hd.jpg","switory-color-M1339-0600-00-31362-07-hd.jpg","switory-color-M1339-0600-00-31362-08-hd.jpg"],"55227882930505":["switory-color-M1898-0600-00-31362-01-hd.jpg","switory-color-M1898-0600-00-31362-02-hd.jpg","switory-color-M1898-0600-00-31362-03-hd.jpg","switory-color-M1898-0600-00-31362-04-hd.jpg","switory-color-M1898-0600-00-31362-05-hd.jpg","switory-color-M1898-0600-00-31362-06-hd.jpg"],"55227882733897":["switory-color-M1934-0800-00-31362-01-hd.jpg","switory-color-M1934-0800-00-31362-02-hd.jpg","switory-color-M1934-0800-00-31362-03-hd.jpg","switory-color-M1934-0800-00-31362-04-hd.jpg","switory-color-M1934-0800-00-31362-05-hd.jpg","switory-color-M1934-0800-00-31362-06-hd.jpg","switory-color-M1934-0800-00-31362-07-hd.jpg","switory-color-M1934-0800-00-31362-08-hd.jpg","switory-color-M1934-0800-00-31362-09-hd.jpg"],"55227882963273":["switory-color-M1935-0600-00-31362-01-hd.jpg","switory-color-M1935-0600-00-31362-02-hd.jpg","switory-color-M1935-0600-00-31362-03-hd.jpg","switory-color-M1935-0600-00-31362-04-hd.jpg","switory-color-M1935-0600-00-31362-05-hd.jpg","switory-color-M1935-0600-00-31362-06-hd.jpg","switory-color-M1935-0600-00-31362-07-hd.jpg","switory-color-M1935-0600-00-31362-08-hd.jpg","switory-color-M1935-0600-00-31362-09-hd.jpg"],"55227883159881":["switory-color-M1936-0250-00-31362-01-hd.jpg","switory-color-M1936-0250-00-31362-02-hd.jpg","switory-color-M1936-0250-00-31362-03-hd.jpg","switory-color-M1936-0250-00-31362-04-hd.jpg","switory-color-M1936-0250-00-31362-05-hd.jpg","switory-color-M1936-0250-00-31362-06-hd.jpg","switory-color-M1936-0250-00-31362-07-hd.jpg","switory-color-M1936-0250-00-31362-08-hd.jpg"],"55227883225417":["switory-color-M1971-0250-00-31362-01-hd.jpg","switory-color-M1971-0250-00-31362-02-hd.jpg","switory-color-M1971-0250-00-31362-03-hd.jpg","switory-color-M1971-0250-00-31362-04-hd.jpg","switory-color-M1971-0250-00-31362-05-hd.jpg","switory-color-M1971-0250-00-31362-06-hd.jpg","switory-color-M1971-0250-00-31362-07-hd.jpg","switory-color-M1971-0250-00-31362-08-hd.jpg"],"55227882996041":["switory-color-M1972-0600-00-31362-01-hd.jpg","switory-color-M1972-0600-00-31362-02-hd.jpg","switory-color-M1972-0600-00-31362-03-hd.jpg","switory-color-M1972-0600-00-31362-04-hd.jpg","switory-color-M1972-0600-00-31362-05-hd.jpg","switory-color-M1972-0600-00-31362-06-hd.jpg","switory-color-M1972-0600-00-31362-07-hd.jpg"],"55227883192649":["switory-color-M3115-0250-00-31362-01-hd.jpg","switory-color-M3115-0250-00-31362-02-hd.jpg","switory-color-M3115-0250-00-31362-03-hd.jpg","switory-color-M3115-0250-00-31362-04-hd.jpg","switory-color-M3115-0250-00-31362-05-hd.jpg","switory-color-M3115-0250-00-31362-06-hd.jpg","switory-color-M3115-0250-00-31362-07-hd.jpg"],"55227883028809":["switory-color-M3693-0600-00-31362-01-hd.jpg","switory-color-M3693-0600-00-31362-02-hd.jpg","switory-color-M3693-0600-00-31362-03-hd.jpg","switory-color-M3693-0600-00-31362-04-hd.jpg","switory-color-M3693-0600-00-31362-05-hd.jpg","switory-color-M3693-0600-00-31362-06-hd.jpg","switory-color-M3693-0600-00-31362-07-hd.jpg","switory-color-M3693-0600-00-31362-08-hd.jpg","switory-color-M3693-0600-00-31362-09-hd.jpg"]}).map(([id, names]) => [id, new Set(names)]));
  const style = document.createElement('style');
  style.textContent = 'media-gallery [data-switory-color-hidden], product-modal [data-switory-color-hidden] { display: none !important; }';
  document.head.appendChild(style);
  function currentVariantId() {
    return new URLSearchParams(location.search).get('variant') ||
      document.querySelector('product-info form[action*="/cart/add"] input[name="id"]')?.value ||
      '55227882602825';
  }
  function filename(node) {
    const src = node.querySelector('img')?.getAttribute('src') || node.getAttribute('src') || '';
    return (src.split('?')[0].split('/').pop() || '').replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.jpg$)/i, '');
  }
  function show(node, visible) {
    if (visible) node.removeAttribute('data-switory-color-hidden');
    else node.setAttribute('data-switory-color-hidden', '');
  }
  function refreshGallery() {
    const allowed = groups[currentVariantId()];
    const gallery = document.querySelector('media-gallery');
    if (!allowed || !gallery) return;
    const slides = [...gallery.querySelectorAll('.product__media-list > li[data-media-id]')];
    if (!slides.length) return;
    let firstVisible = null;
    for (const slide of slides) {
      const visible = allowed.has(filename(slide));
      show(slide, visible);
      if (visible && !firstVisible) firstVisible = slide;
    }
    for (const thumb of gallery.querySelectorAll('.thumbnail-list__item[data-target]')) {
      show(thumb, allowed.has(filename(thumb)));
    }
    const modal = document.querySelector('product-modal');
    if (modal) {
      for (const media of modal.querySelectorAll('.product-media-modal__content > [data-media-id]')) {
        show(media, allowed.has(filename(media)));
      }
    }
    const activeSlide = slides.find((slide) => slide.classList.contains('is-active'));
    if (firstVisible && (!activeSlide || !allowed.has(filename(activeSlide)))) {
      gallery.setActiveMedia?.(firstVisible.dataset.mediaId, true);
    }
  }
  let queued = false;
  function queueRefresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refreshGallery(); });
  }
  function onVariantChange() {
    [0, 150, 500].forEach((delay) => setTimeout(queueRefresh, delay));
  }
  document.addEventListener('change', onVariantChange);
  window.addEventListener('popstate', onVariantChange);
  document.addEventListener('shopify:section:load', onVariantChange);
  new MutationObserver(queueRefresh).observe(document.body, { childList: true, subtree: true });
  onVariantChange();
})();

(function () {
  const path = window.location.pathname;
  if (!path.includes('/products/pe-versandtaschen-mit-griff-selbstklebend-reissfest') &&
      !path.includes('/products/switory-pe-versandtaschen-selbstklebend-blickdicht-500-1-200-stuck') &&
      !path.includes('/products/papiertragetaschen-mit-henkel-stabil-vielseitig') &&
      !path.includes('/products/faltbare-geschenkboxen-mit-deckel-stabil-vielseitig') &&
      !path.includes('/products/transparente-luftpolsterfolie-auf-rolle-reissfest-vielseitig')) return;

  const variantData = document.querySelector('[data-switory-variants]');
  if (!variantData) return;
  let variants;
  try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }
  const skuById = new Map(variants.map((variant) => [String(variant.id), String(variant.sku || '')]));
  const style = document.createElement('style');
  style.textContent = 'media-gallery [data-switory-pe-hidden], product-modal [data-switory-pe-hidden] { display: none !important; }';
  document.head.appendChild(style);

  function selectedSku() {
    const id = document.querySelector('product-info form[action*="/cart/add"] input[name="id"]')?.value ||
      new URLSearchParams(window.location.search).get('variant');
    return skuById.get(String(id)) || '';
  }
  function belongsToSku(node, sku) {
    const alt = (node.matches('img') ? node : node.querySelector('img'))?.getAttribute('alt') || '';
    return alt.startsWith(sku + ' |');
  }
  function show(node, visible) {
    if (visible) node.removeAttribute('data-switory-pe-hidden');
    else node.setAttribute('data-switory-pe-hidden', '');
  }
  function refreshGallery() {
    const sku = selectedSku();
    const gallery = document.querySelector('media-gallery');
    if (!sku || !gallery) return;
    const slides = [...gallery.querySelectorAll('.product__media-list > li[data-media-id]')];
    let firstVisible = null;
    for (const slide of slides) {
      const visible = belongsToSku(slide, sku);
      show(slide, visible);
      if (visible && !firstVisible) firstVisible = slide;
    }
    for (const thumb of gallery.querySelectorAll('.thumbnail-list__item[data-target]')) {
      show(thumb, belongsToSku(thumb, sku));
    }
    const modal = document.querySelector('product-modal');
    if (modal) {
      for (const media of modal.querySelectorAll('.product-media-modal__content > [data-media-id]')) {
        show(media, belongsToSku(media, sku));
      }
    }
    const activeSlide = slides.find((slide) => slide.classList.contains('is-active'));
    if (firstVisible && (!activeSlide || !belongsToSku(activeSlide, sku))) {
      gallery.setActiveMedia?.(firstVisible.dataset.mediaId, true);
    }
  }
  let queued = false;
  function queueRefresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refreshGallery(); });
  }
  function onVariantChange() {
    [0, 150, 500].forEach((delay) => setTimeout(queueRefresh, delay));
  }
  document.addEventListener('change', onVariantChange);
  window.addEventListener('popstate', onVariantChange);
  document.addEventListener('shopify:section:load', onVariantChange);
  new MutationObserver(queueRefresh).observe(document.body, { childList: true, subtree: true });
  onVariantChange();
})();

(function () {
  function installGalleryNavigation() {
    const gallery = document.querySelector('media-gallery');
    const viewer = gallery?.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!viewer || viewer.querySelector('.switory-gallery-nav')) return;

    if (!document.getElementById('switory-gallery-nav-style')) {
      const style = document.createElement('style');
      style.id = 'switory-gallery-nav-style';
      style.textContent = '.product__media-wrapper::before,.product__media-wrapper::after{content:none!important;display:none!important}media-gallery slider-component[id^="GalleryViewer-"]{position:relative}.switory-gallery-nav{position:absolute;top:50%;z-index:5;width:4.4rem;height:4.4rem;transform:translateY(-50%);display:grid;place-items:center;border:1px solid rgba(30,30,30,.16);border-radius:50%;background:rgba(255,255,255,.78);color:#222;box-shadow:0 2px 10px rgba(0,0,0,.12);cursor:pointer;transition:background .18s ease,box-shadow .18s ease,opacity .18s ease;opacity:.88}.switory-gallery-nav[hidden]{display:none!important}.switory-gallery-nav:hover,.switory-gallery-nav:focus-visible{background:rgba(255,255,255,.96);box-shadow:0 3px 14px rgba(0,0,0,.2);opacity:1}.switory-gallery-nav:focus-visible{outline:2px solid #e50046;outline-offset:2px}.switory-gallery-nav--prev{left:1.2rem}.switory-gallery-nav--next{right:1.2rem}.switory-gallery-nav svg{width:1.8rem;height:1.8rem;display:block}@media(max-width:749px){.switory-gallery-nav{width:3.8rem;height:3.8rem}.switory-gallery-nav--prev{left:.8rem}.switory-gallery-nav--next{right:.8rem}}';
      document.head.appendChild(style);
    }

    function visibleSlides() {
      return [...gallery.querySelectorAll('.product__media-list > li[data-media-id]')]
        .filter((slide) => { const thumb = gallery.querySelector('.thumbnail-list__item[data-target="' + slide.dataset.mediaId + '"]'); return thumb ? getComputedStyle(thumb).display !== 'none' : getComputedStyle(slide).display !== 'none'; }).sort((a, b) => { const rank = (slide) => Number((gallery.querySelector('.thumbnail-list__item[data-target="' + slide.dataset.mediaId + '"] button')?.getAttribute('aria-label') || '').match(/[0-9]+/)?.[0] || 0); return rank(a) - rank(b); });
    }
    function move(direction) {
      const slides = visibleSlides();
      if (slides.length < 2) return;
      const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
      const next = slides[(current + direction + slides.length) % slides.length];
      if (next) gallery.setActiveMedia(next.dataset.mediaId, false);
    }
    for (const [direction, label, side, path] of [
      [-1, 'Vorheriges Bild', 'prev', 'M14.5 4.5 9 10l5.5 5.5'],
      [1, 'Nächstes Bild', 'next', 'M5.5 4.5 11 10l-5.5 5.5']
    ]) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'switory-gallery-nav switory-gallery-nav--' + side;
      button.setAttribute('aria-label', label);
      button.innerHTML = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="' + path + '" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); move(direction); });
      viewer.appendChild(button);
    }
    const update = () => {
      const disabled = visibleSlides().length < 2;
      viewer.querySelectorAll('.switory-gallery-nav').forEach((button) => { button.hidden = disabled; });
    };
    update();
    document.addEventListener('change', () => setTimeout(update, 180));
    window.addEventListener('popstate', () => setTimeout(update, 180));
    document.addEventListener('shopify:section:load', () => setTimeout(installGalleryNavigation, 0));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installGalleryNavigation);
  else installGalleryNavigation();
})();
